export { CookieService } from '@mindsorg/ngx-universal';
